import { useMemo, useState, SyntheticEvent } from "react";
import { defaultImgs } from "../../../utils/defaultImages";
import { getUserAvatar } from "../../../utils/getMedia";
import { Invitation } from "../../../types";
import {
  GroupInvitationStatus,
  GroupStatusColor,
} from "../../../api/enums/GroupInvitationStatus";

import _ from "../myPartyDetail.module.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routes/routes";
import handleImgError from "../../../handleImgError";
import { localStorageKeys } from "../../../utils/localStorageKeys";
import AuthenticationResponse from "../../../api/responses/AuthenticationResponse";

export default function InvitedFriend({
  invitedFriend,
  inviter,
  isFirst,
  groupId
}: {
  invitedFriend: Invitation;
  inviter?: Invitation;
  isFirst: boolean;
  groupId: string
}) {
  const [hasPhoto, setHasPhoto] = useState(true);
  const { statusColor, status } = useMemo(() => {
    if (invitedFriend.status === GroupInvitationStatus.Accepted) {
      return {
        statusColor: GroupStatusColor.Green,
        status: GroupInvitationStatus.Accepted,
      };
    } else if (invitedFriend.status === GroupInvitationStatus.Maybe) {
      return {
        statusColor: GroupStatusColor.Gold,
        status: GroupInvitationStatus.Maybe,
      };
    } else if (invitedFriend.status === GroupInvitationStatus.Declined) {
      return {
        statusColor: GroupStatusColor.Red,
        status: GroupInvitationStatus.Declined,
      };
    } else {
      return {
        statusColor: "",
        status: "",
      };
    }
  }, [invitedFriend]);

  const navigate = useNavigate();
  const storedLoginResponse =
    sessionStorage.getItem(localStorageKeys.loginResponse) ??
    localStorage.getItem(localStorageKeys.loginResponse) ??
    "{}";
  const loggedInUser = JSON.parse(storedLoginResponse) as AuthenticationResponse;

  function handleInvitationClick(friendInfo: Invitation) {
    const isCurrentUser =
      friendInfo.firstName === loggedInUser.firstName &&
      friendInfo.lastName === loggedInUser.lastName;

    if (isCurrentUser) {
      navigate(routes.UserProfile);
    }
    else {
      navigate(routes.InvitedFriendInfo(groupId, invitedFriend.id), {
        state: { friendInfo, groupId }
      });
    }
  }

  const getFullName = (invitation: Invitation) => {
    let fullName = '';
    if (invitation.firstName) {
      fullName += invitation.firstName.trim();
    }
    if (invitation.lastName) {
      fullName += ` ${invitation.lastName.trim()}`;
    }
    return fullName.trim();
  };

  const onAvatarLoadError = (event: SyntheticEvent<HTMLImageElement>, gender: string | undefined) => {
    setHasPhoto(false);
    handleImgError(event, invitedFriend.gender.toString());
  };

  const inviterFullName = inviter ? getFullName(inviter) : "";
  return (
    <div className={_.invitedFriendBox} onClick={() => handleInvitationClick(invitedFriend)}>
      <div className={_.avatarImg}>
        <img
          src={getUserAvatar(`${invitedFriend.id}?${Date.now()}`) ?? defaultImgs.Avatar}
          alt="Avatar"
          onError={(event) => { onAvatarLoadError(event, invitedFriend.gender.toString()) }}
        />
      </div>
      <div className={_.infoBox}>
        <div className={_.nameStatusBox}>
          <div className="text-left">
            <div
              className={_.name}
            >{getFullName(invitedFriend)}</div>
            <div className={_.isAdmin}>
              {invitedFriend.isGroupAdmin
                ? "Organizer"
                : inviterFullName
                  ? `Invited by: ${inviterFullName}`
                  : ""}
            </div>
          </div>
          <div className="text-right">
            {status && status != "" && <div style={{ color: statusColor }}>{status}</div>}
            {!hasPhoto && <div style={{ color: 'red' }}>Please add photo</div>}
          </div>

        </div>
      </div>
    </div>
  );
}
